import { retrieveFromStorage } from "../../Components/Functions";
import Api from "../../Server/Api";
import { USER_AUTHENTICATION_DATA } from "../User/types";
import { CLOSE, UPDATE, UPDATERIDERMAP } from "./types";

const api = new Api();
const { business = {} } = retrieveFromStorage(USER_AUTHENTICATION_DATA) || {};

export const updateMap = (data = {}) => {
	return { ...data, type: UPDATE };
};


export const closePanel = (data = {}) => {
	return {
		...data,
		type: CLOSE,
	};
};

export const createOrder = (data = {}, callback = null) => {
	return async (dispatch) => {
		let res = null;
		const _data = {
			"pickup_lat": data?.pickupLocation?.latLng?.lat,
			"pickup_lng": data?.pickupLocation?.latLng?.lng,
			"pickup_address": data?.pickupLocation?.address,
			"pickup_address_component": JSON.stringify(data?.deliveryLocation?.address_component||"[]"),
			"delivery_lat": data?.deliveryLocation?.latLng?.lat,
			"delivery_lng": data?.deliveryLocation?.latLng?.lng,
			"delivery_address": data?.deliveryLocation?.address,
			"delivery_address_component": JSON.stringify(data?.deliveryLocation?.address_component||"[]"),
			"distance": data?.order?.distance,
			"time": data?.order?.time,
			"amount": data?.order?.amount,
			"item_name": data?.order_detail?.item_description,
			"item_description": data?.order_detail?.additional_info,
			"item_image": data?.order_detail?.item_image,
			"map_preview": data?.map_preview,
			"customer": {
				email: data?.order_detail?.email, 
				name: data?.order_detail?.name, 
				phone: data?.order_detail?.phone
			},
			"payment_method": data?.payment?.method,
			"id": data?.id
		};
		
		if(data?.rider_id){
			_data.rider = data?.rider_id;
		}

		if(data?.id){
			res = await api.put({ endpoint: "/orders/"+data?.id+"/", data: _data });
		}else{
			res = await api.post({ endpoint: "business/" + business?.identity + "/orders/", data: _data });
		}

		if(res?.id > 0){
			const d = { type: UPDATE, ...data, order_no: res?.order_no, id: res?.id, status: true }
			dispatch(d);
			callback && callback(d)
			// eslint-disable-next-line no-undef
			notyf.open({
				type: "success",
				message: "Order created successfully",
			});
			return;
		}
		callback && callback({ status: false })
		// eslint-disable-next-line no-undef
		notyf.open({
			type: "error",
			message: res?.detail||res?.message||"Order failed, please try again.",
		});
	};

};



export const updateRidersDirect = (data=[]) => {
	return { type: UPDATERIDERMAP, riders: data }
};

export const updateRiders = (callback) => {
	return async (dispatch) => {
		
	}
};
